import { GET_SUPERVISOR_GROUPS, CREATE_NEW_SUPERVISOR_GROUP, UPDATE_SUP_GROUP, DELETE_SUP_GROUP } from '../../types'

const initialState = {
  groups: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_SUPERVISOR_GROUPS: return {
      ...state,
      groups: action.payload
    }
    case CREATE_NEW_SUPERVISOR_GROUP: return {
      ...state
    }
    case UPDATE_SUP_GROUP: return {
      ...state,
      groups: action.payload
    }
    case DELETE_SUP_GROUP: return {
      ...state
    }
    default: return { ...state }
  }
}
